import { ViewTypeConfigSchema } from "@/domain/ViewTypeConfigSchema";
import { getSheetSchemaTypeMap } from "../../schema/allDependSheets";

// ビュー内で利用することがあるすべてのスキーマを定義

export const MasterEditViewComponentKey =
  "planiumChemicalMasterEditView" as const;

export const MasterEditViewAllSchemaTypeMap = getSheetSchemaTypeMap([
  "purchasePlan",
  "shippingPlan",
  "batchTaskPlan",
  "salesInput",
  "itemMaster",
  "stockCriteriaMaster",
  "rawMaterialMaster",
  "bomMaster",
  "bomRawMaterialMaster",
  "bomByproductItemMaster",
  "deviceMaster",
  "storageMaster",
  "storageItemMaster",
  "batchTaskMaster",
  "switchingBatchTaskMaster",
  "linkTaskMaster",
  "businessDayCalendar",
  "adjustmentInput",
  "deviceMaintenanceInput",
  "memo",
  "bitMaskToPeopleCountMaster",
  "batchTaskToPeopleCountMaster",
  "params",
  "pluginMaster",
  "scoreSummaries",
  "commonStoragePluginMaster",
  "nonBusinessDayAdjacentTaskPluginMaster",
  "taskPriorityPluginMaster",
  "approvalRecord",
  "approverMaster",
]);

export const MasterEditViewAllConfigSchema =
  [] as const as ViewTypeConfigSchema<"">[];

export type MasterEditViewSchemaType = typeof MasterEditViewAllSchemaTypeMap;
